import React from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';

const AboutPage = () => {
  return (
    <Container className="py-5">
      <Row className="justify-content-center">
        <Col lg={8}>
          <Card className="shadow-sm">
            <Card.Body className="p-4 text-start">
              <h1 className="mb-4">About TruthCheckMe</h1>
              
              <p className="lead mb-4">
                TruthCheckMe is an AI-powered truth evaluation tool designed to help users critically analyze the accuracy of any statement. Whether you're fact-checking a claim you saw online, a political statement, or just testing your own assumptions, TruthCheckMe provides a quick and insightful breakdown of how true or false a statement appears to be—backed by reasoning generated by advanced language models.
              </p>

              <h2 className="h3 mb-3">How It Works</h2>
              <p className="mb-4">
                At its core, TruthCheckMe uses OpenAI's ChatGPT to evaluate the truthfulness of user-submitted statements. When you enter a statement into the app, the system analyzes it in the context of publicly available knowledge and reasoning patterns, then returns a <strong>truth grade</strong> (from "Absolutely False" to "Truth") along with a short explanation.
              </p>
              <p className="mb-4">
                This approach doesn't just tell you whether something is true or false—it encourages <strong>critical thinking</strong> by providing context for the evaluation.
              </p>

              <h2 className="h3 mb-3">Why We Built It</h2>
              <p className="mb-4">
                With misinformation on the rise and trust in information sources constantly shifting, we believe everyone should have access to simple, powerful tools to help them navigate the truth. TruthCheckMe was created to empower individuals to:
              </p>
              <ul className="mb-4">
                <li>Ask better questions</li>
                <li>Challenge questionable claims</li>
                <li>Develop stronger media literacy skills</li>
              </ul>
              <p className="mb-4">
                This tool is meant to be <strong>accessible, fast, and free</strong> for anyone who wants to think more critically about the information they encounter every day.
              </p>

              <h2 className="h3 mb-3">Limitations</h2>
              <p className="mb-4">
                TruthCheckMe is powered by a large language model and should not be considered an ultimate authority on any topic. The reasoning provided is based on patterns learned from data and may not always reflect the most current or nuanced information available. Always consult multiple trusted sources when verifying critical facts.
              </p>

              <p className="mb-4">
                Knowledge of the world is limited up to October 2023. Statements about events after that date may not be answered correctly.
              </p>

              <h2 className="h3 mb-3">Future Plans</h2>
              <p className="mb-4">
                We're actively working on new features, including:
              </p>
              <ul className="mb-4">
                <li>Improved grading transparency</li>
                <li>Improved sourcing of citations for supporting evidence</li>
                <li>A Chrome extension for on-the-fly fact checks</li>
              </ul>

              <p className="small text-muted mt-4 pt-3 border-top">
                This tool is not affiliated with OpenAI or any other organization. It is a personal project created by <a href="https://github.com/jpmestres" className="text-muted">Jean-Paul Mestres</a>.
              </p>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default AboutPage; 